export const enum EditableTexts {
  FormTitle = 'Make a donation',
  PageTitle = 'Make a difference',
  PageDescription = 'Change starts with people like you. Your donation helps make a real impact, one action at a time. Together, we can do more.',
  FormDescription = 'This is your campaign description. It’s a great place to tell visitors what this campaign is about, connect with your donors and draw attention to your cause.',
}
